//#region Libraries
import { useState } from "react";
//#endregion
//#region Styles
import { Column } from "components/styles";
import { Description } from "./styles";
//#endregion
//#region Components
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import CustomButton from "components/CustomButton/CustomButton";
import CustomTextArea from "components/CustomTextArea/CustomTextArea";
//#endregion
//#region Images
//#endregion
//#region Services
//#endregion
//#region Utils
//#endregion

const DialogDeletionResource = ({
    dialogShow,
    serviceName,
    serviceTypeName,
    deleteResource
}) => {
    //#region States
    const [reasonForDeletion, setReasonForDeletion] = useState({
        value: "",
        error: false
    });
    //#endregion
    //#region Functions
    const changeReasonForDeletion = value => {
        setReasonForDeletion({
            error: false,
            value
        });
    }
    const doDeleteResource = () => {
        // Validando motivo lleno
        if (!reasonForDeletion.value) {
            setReasonForDeletion(prev => ({
                ...prev,
                error: true
            }));
            return;
        }
        dialogShow.toggle(false);
        deleteResource(reasonForDeletion.value);
    }
    //#endregion
    return (
        <DialogAlertAction
            minWidth="300px"
            width="620px"
            show={dialogShow.value}
            toggleShow={dialogShow.toggle}
            variant="secondary"
            title={`¿Deseas eliminar la ${serviceName}?`}
            contentComponent={
                <Column width="100%">
                    <Description>Para eliminar esta {serviceTypeName} por favor ingresa el motivo y recuerda que ya no estará visible en la pantalla principal.</Description>
                    <CustomTextArea 
                        placeholder="Escribe el motivo"
                        value={reasonForDeletion.value}
                        onChange={changeReasonForDeletion}
                        error={reasonForDeletion.error}
                        errorText="Es necesario ingresar el motivo de eliminación"
                        maxLength={100}
                        height="60px"/>
                </Column>}>
            <CustomButton 
                variant="secondary"
                width="125px"
                text="No, cancelar"
                onClick={() => dialogShow.toggle(false)}/>
            <CustomButton 
                width="125px"
                text="Si, eliminar"
                onClick={doDeleteResource}/>
        </DialogAlertAction>
    );
}

export default DialogDeletionResource;